/* eslint-disable react-hooks/exhaustive-deps */
import { Avatar, List, ListItem, ListItemAvatar, ListItemText, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch} from "react-redux";
import { styles } from "../../../theme";
import AppScreenLoader from "../../../../../components/AppScreenLoader";
import { addSkipIndex } from "../../../../../store/actions";
import { getCurrencyListFiat } from "../../../../../store/api";
import { S3_GYL_ICONS } from "../../../../../utils/config";

export default function PayerSelect({ amount, active, setActive, country, paymentPayer, paymentCurrency, setPaymentCurrency, setPaymentPayer, paymentMethod, setDestinationId }) {
    const [payers, setPayers] = useState([]);
    const dispatch = useDispatch();
    useEffect(() => {
        fetchMethods();
    }, [])
    const fetchMethods = async () => {
        const response = await getCurrencyListFiat(amount, country.three_letter_code, paymentMethod.actualValue);
        // setDestinationId(response.result.destinationRecordId);
        setPayers(response.result.payers)
    }
    const handlePaymentMethod = (value) => {
        setPaymentPayer(value)
        setDestinationId(value.destinationRecordId);
        // check if currency is 1 if yes active  + 2 or active + 1
        if (value.currencySymbols && value.currencySymbols.length === 1) {
            setPaymentCurrency(value.currencySymbols[0]);
            dispatch(addSkipIndex(active + 1));
            setActive(active + 2);
        } else {
            setActive(active + 1);
        }
    }
    if (!payers || !payers.length) {
        return <AppScreenLoader />
    }
    const getIcon = (icon) => {
        try {
            const Logo = `${S3_GYL_ICONS}/fiat/${icon.toLowerCase()}.svg`;
            return Logo;
        } catch (err) {
            return ""
        }
    }
    return (<Paper
        sx={{
            backgroundColor: "transparent",
            boxShadow: "none",
            paddingTop: 1,
        }}
    >
        <List>
            {payers.map((value, index) => (
                <ListItem
                    key={index}
                    style={value === paymentPayer?.name ? styles.selected : {}}
                    onClick={(ev) => handlePaymentMethod(value)}
                >
                    <ListItemAvatar>
                        <Avatar>
                            <img src={getIcon(value.icon)} alt="icon" />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText 
                        primary={`${value?.name}`} 
                        secondary={`Fee: ${value?.feeText || ''}`}
                    />
                </ListItem>
            ))}
        </List>
    </Paper>)
}